import { IomData } from "../../../../../../pages/Settings/YachtSetup/VesselParticulars/YachtSetup.types";
import { Fragment, memo, useEffect } from "react";
import { Button } from "../../../../../shared/Button/Button";
import { ActionIcon, Input, Text } from "@mantine/core";
import { Flex } from "../../../../../../styled";
import { IconPlus, IconTrash } from "@tabler/icons-react";

interface Props {
  data: IomData;
  dataKey: string;
  onAddField: (key: string) => void;
  onDeleteField: (key: string, index: number) => void;
  onChangeField: (key: string, index: number, value: string) => void;
}
const IomInput = ({
  data,
  onAddField,
  onChangeField,
  dataKey,
  onDeleteField,
}: Props) => {
  return (
    <Flex direction="column" w="70%">
      <Flex justify="space-between">
        <Text size="sm">{data.name}</Text>
        <ActionIcon color="blue" onClick={() => onAddField(dataKey)}>
          <IconPlus />
        </ActionIcon>
      </Flex>
      <Flex direction="column" gap={7} my={5}>
        {data.list.map((item, index) => (
          <Flex gap={5} align="center">
            <Input
              key={`${dataKey}-${index}`}
              value={item}
              onChange={e => onChangeField(dataKey, index, e.target.value)}
              style={{ flex: 1 }}
            />
            <ActionIcon
              color="red"
              onClick={() => onDeleteField(dataKey, index)}>
              <IconTrash />
            </ActionIcon>
          </Flex>
        ))}
      </Flex>
    </Flex>
  );
};
export default memo(IomInput);
